// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ConversionSvg from '@rsuite/icon-font/lib/action/Conversion';
var Conversion = createSvgIcon({
  as: ConversionSvg,
  ariaLabel: 'conversion',
  category: 'action',
  displayName: 'Conversion'
});
export default Conversion;